import './styles.scoped.css'
import {useEffect} from 'react'
import {Typography, Button, Modal, TextField} from '@mui/material'
import {useGlobalStates} from '../../../../contexts/GlobalStatesContext'
import {caregiverApi} from '../../../../services'
import {useForm} from 'react-hook-form'
import {yupResolver} from '@hookform/resolvers/yup'
import * as yup from 'yup'
import {parseError} from '../../../../utils/helpers'
import {useParams} from 'react-router-dom'

export default ({open, setOpen, data, loadData}) => {
    const {setLoading, setMessageBox, branchId} = useGlobalStates()
    const {caregiverId} = useParams()
    const form = useForm({
        resolver: yupResolver(
            yup.object().shape({
                deletion_reason: yup.string(),
            }),
        ),
    })

    useEffect(() => {
        form.reset()
    }, [open])

    const handleOk = reason => {
        setLoading(true)
        caregiverApi
            .deleteCaregiverClient(branchId, caregiverId, data?.id, {
                data: {
                    deletion_reason: reason?.deletion_reason ? reason?.deletion_reason : 'Client no longer requires this service.',
                },
            })
            .then(() => {
                setLoading(false)
                setOpen(false)
                setMessageBox({
                    status: 'success',
                    title: 'Client Removed!',
                    description: `${data?.client?.first_name} has been removed from ${data?.caregiver?.first_name}'s assigned client.`,
                })
                loadData()
            })
            .catch(error => {
                setLoading(false)
                setOpen(false)
                const {title, description} = parseError(error)
                if (description) {
                    setMessageBox({status: 'error', title, description})
                }
            })
    }

    return (
        <Modal open={open}>
            <div className="container">
                <div className="content">
                    <div className="title">
                        <Typography variant="h6" color="text.primary">
                            You are about to remove "{data?.client?.first_name}" from {data?.caregiver?.first_name}'s assigned client.
                        </Typography>
                    </div>
                    <br />
                    <Typography variant="body2" color="text.primary" style={{textAlign: 'center'}}>
                        This action cannot be undone. The client may need to be reassigned to another caregiver.
                    </Typography>
                    <br />
                    <Typography variant="inputLabel" color="text.secondary">
                        Reason
                    </Typography>
                    <TextField placeholder="Please tell us the reason..." fullWidth multiline rows={5} {...form.register('deletion_reason')} />
                    <br />
                    <br />
                    <div className="actions">
                        <Button variant="outlined" fullWidth onClick={() => setOpen(false)}>
                            Cancel
                        </Button>
                        <Button variant="contained" fullWidth color="error" onClick={form.handleSubmit(handleOk)}>
                            Confirm Removal
                        </Button>
                    </div>
                </div>
            </div>
        </Modal>
    )
}
